import React, { useEffect, useState } from "react";
import MarkesEvaluationTable from "../../Components/MarkesEvaluationTable";
import YesNoTable from "../../Components/yesNoTable";
import RecommendationsSection from "../../Components/RecommendationsSection";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import { useDispatch, useSelector } from "react-redux";
import { GetAllMarksBySubTaskGuid } from "../../Redux/Reducers/MarksManager";
import { GetAllYesNoListByTaskGuid } from "../../Redux/Reducers/YesNoManager";
import { useParams } from "react-router-dom";
import { GetComponentByFlow } from "../../Redux/Reducers/ComponentByFlow";
import { GetActionButtons } from "../../Redux/Reducers/ActionButtons";
import ButtonActionManager from "../ButtonActionManager";
import InputAHSF from "../../Components/InputAHSF";
import { GetHeaderTaskPageData } from "../../Redux/Reducers/HeaderTaskPageData";
import {
  ChangeStatustSubTaskById,
  GetSubTaskById,
} from "../../Redux/Reducers/SubTaskFlow";
import { useCookies } from "react-cookie";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { encryptToken } from "../../Services/Account/EncryptionParams";
import { jwtDecode } from "jwt-decode";
import LoaderAHSF from "../../Components/LoaderAHSF";

export default function AllComponentPage(props) {
  const dispatch = useDispatch();
  let { flow } = useParams();
  let { taskId } = useParams();
  let { mainTaskId } = useParams();
  const [cookies, setCookie] = useCookies([]);
  const [loading, setLoading] = useState(true);

  //[,]
  // فك تشفير ال  param
  const decodeParam = (param) => atob(param);

  const state = useSelector((state) => {
    return {
      MarksManager: state.MarksManager.MarksManager,
      loadingMarksManager: state.MarksManager.loadingMarksManager,
      YesNoManagerBySubTask: state.YesNoManagerBySubTask?.YesNoManagerBySubTask,
      loadingYesNoManagerBySubTask: state.loadingYesNoManagerBySubTask,
      OneComponentByFlow: state.OneComponentByFlow,
      ActionButtons: state.ActionButtons.ActionButtons,
      loadingActionButtons: state.ActionButtons.loadingActionButtons,
      HeaderTaskPageData: state.HeaderTaskPageData.HeaderTaskPageData,
      subTaskFlowByGUID: state.SubTaskFlow.subTaskFlowByGUID,

      UserInfo: state.UserInfo.UserInfo,
    };
  });
  let userInfoData = jwtDecode(cookies.loginTokenSSO);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    //[,]
    //to get all components by flow
    const GetComponent = await dispatch(
      GetComponentByFlow({
        appiliacationInfo: localStorage.getItem(
          "aI_ApplicationInformationId_Manager"
        ),
        flowGUID: decodeParam(flow),
      })
    );
    //---------------------------------------------------------------
    //[,]
    //to get application information by guid
    const GetHeader = await dispatch(
      GetHeaderTaskPageData(
        localStorage.getItem("aI_ApplicationInformationId_Manager")
      )
    );
    //---------------------------------------------------------------

    //[,]
    //to get subtask info  by taskId
    const GetSubTask = await dispatch(GetSubTaskById(decodeParam(taskId)));
    //---------------------------------------------------------------

    //[,]
    //to get all  action  buttons
    const GetAction = await dispatch(
      GetActionButtons({
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId_Manager"
        ),
        flowGUID: decodeParam(flow),
        isMainFlow: false,
      })
    );
    if (
      GetAction.payload &&
      GetSubTask.payload &&
      GetHeader.payload &&
      GetComponent.payload
    ) {
      setLoading(false);
    }
  };
  // //console.log(state.subTaskFlowByGUID?.applicationGUID, "state.subTaskFlowByGUID");
  //[,]
  //to sort componentflow by rowOrder
  let sortedComponents = [];
  if (state.OneComponentByFlow?.OneComponentByFlow) {
    sortedComponents = [...state.OneComponentByFlow.OneComponentByFlow].sort(
      (a, b) => a.rowOrder - b.rowOrder
    );
  }

  //[,]
  //components name from backend and frontend
  const componentMap = {
    Marks: MarkesEvaluationTable,
    Recommendations: RecommendationsSection,
    YesNo: YesNoTable,
  };

  const ChangeTaskStatus = async () => {
    const changed = await dispatch(
      ChangeStatustSubTaskById(decodeParam(taskId))
    );
    if (changed.payload) {
      window.location.reload();
    }
  };
  return (
    <>
      <div>
        <SharedDiv
          showTitle={true}
          showButton={true}
          id_Title="withBtnTitle"
          buttonComponent={[
            <>
              {/* // [,] */}
              {/* //this btn to open application on new tab with guid in params */}
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  let application = encryptToken(
                    state.subTaskFlowByGUID?.applicationGUID
                  );
                  window.open(
                    `/grants/manager/ApplicationInformation/` + application,
                    "_blank"
                  );
                }}
                id="btnTitle"
                disabled={false}
                title={"عرض الطلب"}
                text={"عرض الطلب"}
                show={true}
              />
              {state.subTaskFlowByGUID?.taskStatusGUID ==
                "0580a04b-1800-48fd-804e-3e48dfea16b3" &&
              state.subTaskFlowByGUID?.userGUID == userInfoData?.UserGuid ? (
                <ButtonAHSF
                  type={"submitter"}
                  onClick={() => {
                    ChangeTaskStatus();
                  }}
                  id="btnTitle"
                  disabled={false}
                  title={"التعديل على التقييم"}
                  text={"التعديل على التقييم"}
                  show={true}
                />
              ) : (
                ""
              )}
            </>,
          ]}
          titleName="معلومات الطلب"
          child={[
            <div className="form-grid">
              <InputAHSF
                fieldsName="ApplicationNumberInput"
                show={true}
                disabled={true}
                value={state.HeaderTaskPageData?.applicationNumber}
              />
              <InputAHSF
                fieldsName="M_ProjectName"
                show={true}
                disabled={true}
                value={state.HeaderTaskPageData?.projectName}
              />
              <InputAHSF
                fieldsName="M_ApplicantName"
                show={true}
                disabled={true}
                value={state.HeaderTaskPageData?.applicantNem}
              />

              <InputAHSF
                fieldsName="ResponsiblePerson"
                show={true}
                disabled={true}
                value={
                  state.subTaskFlowByGUID?.uS_User
                    ? state.subTaskFlowByGUID?.uS_User?.firstName +
                      " " +
                      state.subTaskFlowByGUID?.uS_User?.lastName
                    : "غير محدد"
                }
              />
              <InputAHSF
                fieldsName="M_subTaskName"
                show={true}
                disabled={true}
                value={state.subTaskFlowByGUID?.taskFlow?.flow?.flowName}
              />
              <InputAHSF
                fieldsName="M_subTaskStatus"
                show={true}
                disabled={true}
                value={state.subTaskFlowByGUID?.wfTaskStatus?.taskStatusName}
              />
            </div>,
          ]}
        />
        {/* //[,] */}
        {/* to show render components by flow */}
        {sortedComponents.map((component) => {
          const ComponentToRender =
            componentMap[component.flowComponentTypeName];

          return ComponentToRender ? (
            <ComponentToRender
              key={component.flowComponentRoundGuid}
              flowGUID={component.flowGUID}
              taskId={decodeParam(taskId)}
              flowComponentName={component.flowComponentName}
              flowComponentTypeName={component.flowComponentTypeName}
              disabled={
                state.subTaskFlowByGUID?.taskStatusGUID ==
                  "b8207a91-b6c1-4284-89c7-3acd8a492875" ||
                state.subTaskFlowByGUID?.taskStatusGUID ==
                  "0580a04b-1800-48fd-804e-3e48dfea16b3" ||
                state.subTaskFlowByGUID?.userGUID != userInfoData?.UserGuid
                  ? true
                  : false
              }
            />
          ) : (
            <></>
          );
        })}
        {state.ActionButtons &&
        state.ActionButtons.length > 0 &&
        state.subTaskFlowByGUID?.taskStatusGUID !==
          "b8207a91-b6c1-4284-89c7-3acd8a492875" &&
        state.subTaskFlowByGUID?.taskStatusGUID !==
          "0580a04b-1800-48fd-804e-3e48dfea16b3" &&
        state.subTaskFlowByGUID?.userGUID == userInfoData?.UserGuid ? (
          <ButtonActionManager
            list={state.ActionButtons}
            subTaskGuid={decodeParam(taskId)}
            taskGuid={decodeParam(mainTaskId)}
            typeTasks={false}
            // onUpdateActionButton={onUpdateActionButton}
          />
        ) : (
          ""
        )}
      </div>
      <LoaderAHSF show={loading} />
    </>
  );
}
